import { useRef, useState, useEffect } from "react";
import clsx from "clsx";
import styles from "./STAccordion.module.css";
import { Icons } from "@/const/icons";

export const STAccordion = ({ items = [], defaultOpen = null, isDark }) => {
  const [openIndex, setOpenIndex] = useState(null);
  const contentRefs = useRef([]);

  // ✅ FIX: handle defaultOpen properly (1-based → index)
  useEffect(() => {
    if (
      typeof defaultOpen === "number" &&
      defaultOpen > 0 &&
      defaultOpen <= items.length
    ) {
      setOpenIndex(defaultOpen - 1);
    }
  }, [defaultOpen, items.length]);

  const toggleAccordion = (index) => {
    setOpenIndex((prev) => (prev === index ? null : index));
  };

  return (
    <div
      className={clsx(
        styles.accordion,
        isDark && styles.darkAccordion,
        " radius-md ovreflow-hidden",
      )}
    >
      {items.map((item, index) => {
        const isOpen = openIndex === index;
        const contentHeight =
          isOpen && contentRefs.current[index]
            ? contentRefs.current[index].scrollHeight
            : 0;

        return (
          <div
            key={item.id || index}
            className={clsx(styles.item, isOpen && styles.active)}
          >
            <button
              className={clsx(
                styles.header,
                "w-100 border-0 d-flex justify-content-between align-items-center cursor-pointer text-start gap-sm",
              )}
              onClick={() => toggleAccordion(index)}
            >
              <h3 className="secondary-title mb-0 h5">{item.question}</h3>

              <span className={clsx(styles.icon, "transition-smooth")}>
                {isOpen ? Icons.minusIcon : Icons.plusIcon}
              </span>
            </button>

            <div
              ref={(el) => (contentRefs.current[index] = el)}
              className={styles.content}
              style={{ height: contentHeight }}
            >
              <div className={styles.inner}>
                <p className="paragraph-text mb-0">{item.answer}</p>
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
};
